<template>
  <div>
    <ExcelImport @onDataImported="onDataImported" />
    <div v-if="loading" class="d-flex justify-center align-center flex-column my-2">
      <v-progress-circular indeterminate color="primary"/>
      <div class="mt-2">Đang lấy danh sách học sinh</div>
    </div>
    <ListStudentsIndependent v-show="!loading" :isSenderMethodShown="false" class="mt-2" />
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import ExcelImport from '@/modules/excel-import/index.vue'
import ListStudentsIndependent from '@/modules/post/selectStudentDialog/ListStudentsIndependent.vue'

export default {
  components: { ExcelImport, ListStudentsIndependent },
  data: () => ({ loading: false }),
  methods: {
    ...mapActions('students', ['fetchStudentsForTuitionNoti']),
    ...mapMutations('tuitionFeeGroupStudent', ['setSelectedStudent']),
    async onDataImported(data = []) {
      const res = await this.fetchStudentsForTuitionNoti({ codes: data.map(x => x.code), _populate: 'currentClass' })
      this.setSelectedStudent(res)
      this.$emit(
        'on-student-import',
        res.map(x => x.id)
      )
    },
    reset() {
      this.setSelectedStudent([])
    },
    async init(ids = []) {
      try {
        this.loading = true
        const res = await this.fetchStudentsForTuitionNoti({ ids, _populate: 'currentClass' })
        this.setSelectedStudent(res)
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
